import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CartStorage } from 'src/app/storage/cart';

@Component({
  selector: 'app-promo-t6',
  templateUrl: './promo-t6.component.html',
  styleUrls: ['./promo-t6.component.scss']
})

export class PromoT6Component {
  defImgProd:string = "assets/img/logo_nina_placeholder.jpg"
  products: any = [];
  dataPromo: any = null;
  dataBranch: any = null;
  promo:string = "";
  selectedProductData:any = null;
  code:string = "";
  btnDisabled:boolean = false;

  constructor(private cdr: ChangeDetectorRef, private loaderService:LoaderService, private coreService:CoreService, public apiServices: ApiService, public cookies: CookieService, public route: ActivatedRoute, public router: Router){
    if(this.cookies.check('DataPromo') && (this.cookies.check('Branch') || this.cookies.check('BranchTemp'))){
      this.dataPromo = JSON.parse(this.cookies.get('DataPromo'))
      if(this.cookies.check('Branch')){
        this.dataBranch = JSON.parse(this.cookies.get('Branch'))
      }
      else if(this.cookies.check('BranchTemp')){
        this.dataBranch = JSON.parse(this.cookies.get('BranchTemp'))
      }
      else{
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la sucursal"} });
        this.router.navigate(['/promotions'])
      }
      this.getProducts()
    }
    else{
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la promoción"} });
      this.router.navigate(['/promotions'])
    }
  }

  ngOnInit(): void {

  }

  getProducts(){
    let data = { token: this.cookies.get('Token'), idSucursal:this.dataBranch.idSucursal, idOferta: this.dataPromo.idPromo, idCliente: this.dataPromo.idCliente }
    this.loaderService.show()
    this.apiServices.getProductosPromoCOPorSucursal(data).subscribe({
      next: (value) => {
        this.promo = value.tituloPromocion
        this.products = value.listaDeProductos;
        if(value.listaDeProductos.length === 0){
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Esta promoción no esta disponible el día de hoy, pero puedes disfrutar otras disponibles"} });
          this.router.navigate(['/promotions'])
          return;
        }
        this.products.forEach((product:any) => {
          product.selected = false;
        });
        this.loaderService.hide()
        this.cdr.detectChanges();},
      error: (err) => {
        this.loaderService.hide()
      }
    })
  }

  selectedProduct(product:any){
    if(this.selectedProductData != null){
      this.selectedProductData.selected = false;
    }
    this.selectedProductData = product;
    this.selectedProductData.selected = true;
  }

  canjear(){
    if(this.selectedProductData != null){
      this.verifyCode();
    }
    else{
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Selecciona un producto para canjear la promoción"} });
    }
  }

  verifyCode(){
    this.btnDisabled = true;
    let data = { token: this.cookies.get('Token'), idCliente:this.dataPromo.idCliente, idPromocion: this.dataPromo.idPromo, CodigoCanje: this.code }
    this.apiServices.permisoParaAceptarCodigoCanjeProductoGratis(data).subscribe({
      next:(value) => {
        if(value[0].codigoAceptado){
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Código canjeado exitosamente"} });
          let cartPromo = []
          if(CartStorage.exists()){
            cartPromo = CartStorage.getCart()
          }
          this.selectedProductData.qty = 1
          this.selectedProductData.promo = true
          this.selectedProductData.idPromo = this.dataPromo.idPromo
          this.selectedProductData.tipo = 6
          cartPromo.push(this.selectedProductData)
          const tomorrow = new Date();
          tomorrow.setHours(0, 0, 0, 0);
          tomorrow.setDate(tomorrow.getDate() + 1);
          CartStorage.saveCart(cartPromo)
          if(!this.cookies.check('Branch')){
            this.cookies.set('Branch', JSON.stringify(this.dataBranch), {expires: tomorrow, sameSite: 'Strict'})
            if(this.cookies.check('BranchTemp')){
              this.cookies.delete('BranchTemp', '/');
            }
          }
          this.coreService.emitSubjet.next({ type: 'Cart', payload: null});
          setTimeout(() => {
            this.router.navigate(['/cart'])
          }, 1500)
        }
        else{
          this.btnDisabled = false;
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: value[0].mensajeError} });
        }
      },
      error:(err) => {
        console.error(err)
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Hubo un error al procesar tu solicitud"} });
      },
    })
  }

  onCodeInput(event: any) {
    let value = event.target.value;
    value = value.toUpperCase();
    value = value.replace(/[^A-Z0-9]/g, '');
    value = value.substring(0, 10);

    this.code = value;
  }
}
